import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { HasRampContainer } from './HasRampContainer';
import { WheelchairAccessibleContainer } from './WheelchairAccessibleContainer';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useRuntimeSetting } from 'shared/hooks';

export const AccessibleEnvironmentContainer: FC = () => {
  const isEnabled = useRuntimeSetting('BX.AccessibleEnvironmentFilter.Enabled', false);

  if (!isEnabled) {
    return null;
  }

  return (
    <AdvancedFilterRow label="Доступная среда">
      <InlineFilterGroup>
        <InlineFilter>
          <HasRampContainer />
        </InlineFilter>
        <InlineFilter>
          <WheelchairAccessibleContainer />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
